module.exports = "<p>\n  chooser works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/chooser/chooser.component.html
// module id = ./src/app/shared/chooser/chooser.component.html
// module chunks = main